// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LiveStage__mainContentWrapper___Aghkz{padding:0 0 .8vw 0;box-sizing:border-box}", ""]);
// Exports
exports.locals = {
	"mainContentWrapper": "LiveStage__mainContentWrapper___Aghkz"
};
module.exports = exports;
